import axios from "./axiosinstance";

const LeadFinalApi = {
  add: (payload) => axios.post("leads/add", payload),
  assignBulk: (payload) => axios.post("leads/assignBulk", payload),
  // autoAssign: () => axios.post("leads/auto-assign"),
  update: (payload) => axios.post("leads/update", payload),
  list: (params) => axios.get("leads/list", { params }),
  details: (id) => axios.get(`leads/${id}`),
  getLeadCount: () => axios.get("leads/getLeadCount"),
  updateLeadAssign: (payload) => axios.post("leads/leadAssignUpdate", payload),
  delete: (payload) => axios.post("leads/delete", payload),
};

export default LeadFinalApi;
